import { Line } from '@ant-design/charts'
import { mergeDeepRight, prop, propEq, sum } from 'ramda'
import React from 'react'

import { useColors } from '../../../kiti/components/theme/_hooks/colors'

const LineChart = ({ data, xField, yField, seriesField, ...props }) => {
  const colors = useColors()

  const config = mergeDeepRight(
    {
      data,
      xField,
      yField,
      seriesField,
      isGroup: true,
      smooth: true,
      animation: false,
      autoFit: true,
      legend: {
        position: 'top-right',
        itemValue: {
          formatter: (type, item) => {
            const total = sum(data.filter(propEq(seriesField, type)).map(prop(yField)))
            return `:  ${total}`
          }
        }
      },
      point: {
        size: 3,
        shape: 'circle'
      }
    },
    props
  )

  return <Line {...config} />
}

export default LineChart
